module.exports = __webpack_public_path__ + "img/attractions-churras.4ddfd11c.jpg";